import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    isLoadingData: false,

    user: null,
}

// getters
const getters = {
    isLoadingData: state => state.isLoadingData,

    user: state => state.user,
}

// actions
const actions = {
    getInitData ({ commit }) {
        let params = {
            'handler': 'application',
            'func': 'getInitData',
        };
        commit('setLoadingData', true);
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('favorite/setFavoriteItems', responseData.data.data.listFavoritesProductsId,{ root:  true });
            commit('favorite/setFavoriteMessages', responseData.data.data.favoriteMessages,{ root:  true });
            commit('compare/setCompareItems', responseData.data.data.listCompareProductsId,{ root:  true });
            commit('basket/setBasketMessages', responseData.data.data.basketMessages,{ root:  true });
            commit('basket/setBasketItems', responseData.data.data.basketItems,{ root:  true });
            commit('basket/setCurrency', responseData.data.data.currency,{ root:  true });
            commit('basket/setBasketTotalSum', responseData.data.data.totalPrice,{ root:  true });
            commit('basket/setBasketCount', responseData.data.data.basketCount,{ root:  true });
            commit('setUser', responseData.data.data.user);
            commit('setLoadingData', false);
        });
    },
}

// mutations
const mutations = {
    setLoadingData(state, isLoadingData) {
        state.isLoadingData = isLoadingData;
    },
    setUser (state, user) {
        state.user = user;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
